module.exports = __webpack_public_path__ + "static/media/bg-cross-sell-horizontal.td.e195ac7a.jpg";